import { CorvalBusinessFunction, CorvalColor, CorvalCompletionState, CorvalCriticality, CorvalUIColor, IEntityColorDefintion, IEntityIconDefintion, SemanticUIColor } from '../types';
import { SemanticICONS }                                                                                                                                              from 'semantic-ui-react';


export const ENTITY_ICONS: IEntityIconDefintion = {
    SYSTEM:             {
        SETTINGS: 'cog',
        SUPPORT:  'comment alternate outline',
    },
    QUESTIONS:          {
        CORE:     'list alternate',
        ADDITIVE: 'tasks',
        PROJECT:  'folder outline',
    },
    DATA_VALUE_SETS:    'list',
    MILESTONES:         {
        ENTITY: 'calendar outline',
        ITEM:   'square',
        CUSTOM: 'stop circle',
    },
    ASSUMPTIONS:        {
        ENTITY: 'clipboard outline',
        GROUPS: 'list alternate',
    },
    OBJECTIVES:         {
        GROUPS: 'object group',
    },
    SUBOBJECTIVES:      {
        ENTITY:        'bullseye',
        VISUALIZATION: 'map outline',
        STATUS:        'check circle',
        STATUSES:      {
            NOT_STARTED:      'circle outline',
            IN_PROGRESS_LOW:  'dot circle outline',
            IN_PROGRESS_MED:  'dot circle outline',
            IN_PROGRESS_HIGH: 'dot circle outline',
            COMPLETE:         'check circle',
        }
    },
    ACTIVITIES:         {
        ENTITY:              'lightning',
        VISUALIZATION_GRID:  'list layout',
        VISUALIZATION_GANTT: 'signal',
        RECURRENCE:          'redo',
        RISK_RATING:         'asterisk',
        RISKS:               {
            LATE_COMPLETION: 'clock outline',
            AT_RISK:         'warning sign',
            NONE:            'ban',
        },
        STATUS:              'check circle outline',
        STATUSES:            {
            NOTSTARTED: 'circle outline',
            INCOMPLETE: 'dot circle outline',
            COMPLETE:   'check circle',
            EXCLUDED:   'eye slash',
        },
        TIMING:              {
            EARLY:  'paper plane outline',
            NORMAL: 'clock',
            LATE:   'clock outline',
        },
        CRITICALITY_RATING:  'dot circle',
        CRITICALITY:         {
            CRITICAL: 'warning circle',
            PRIORITY: 'star',
            MODERATE: 'angle double up',
            MINOR:    'angle up',
        }
    },
    USER:               {
        ENTITY:   'user',
        WATCHER:  'user circle outline',
        RESOURCE: 'user circle outline',
        LOGOUT:   'sign-out',
    },
    USER_ROLES:         {
        SYSTEM:         {
            CORVALADMIN:         'user circle',
            ACCOUNTSADMIN:       'user circle',
            DECISIONENGINEADMIN: 'user circle',
            MEMBER:              'user circle outline',
        },
        ORGANIZATIONAL: {
            ADMIN:  'user circle',
            MEMBER: 'user circle outline',
        },
        PROJECT:        {
            ADMIN:  'user circle',
            MEMBER: 'user circle outline',
            VIEWER: 'user circle outline',
        }
    },
    PROJECTS:           {
        ENTITY:             'briefcase',
        SUBSCRIPTION_TYPES: {
            FREEUNLIMITED: 'briefcase'
        },
        TEMPLATES:          {
            ENTITY: 'clone',
            TYPES:  {
                FULLY_PACKAGED:   'briefcase',
                GLOBALLY_FOCUSED: 'globe',
                RESOURCE_FOCUSED: 'group',
                BUDGET_FOCUSED:   'usd',
                TACTICAL:         'tasks',
                PRECISION:        'bullseye',
                STRUCTURED:       'sitemap',
                TIME_SENSITIVE:   'clock outline',
                TARGETED:         'crosshairs',
                EXPERIMENTAL:     'cogs',
                LOCKED:           'lock',
                DO_NOT_USE:       'ban',
            }
        }
    },
    BUSINESS_FUNCTIONS: {
        ENTITY:             'cube'
    },
    CATEGORIES:         {
        ENTITY:                      'tag',
        GENERIC:                     'tasks',
        COMPANY_STRATEGY_PLANNING:   'building',
        ASSET_STRATEGY_PLANNING:     'lab',
        MEDICAL_SCIENTIFIC_AFFAIRS:  'dna',
        VALUE_MARKET_ACCESS:         'dollar sign',
        MARKET_DEVELOPMENT_PLANNING: 'bullhorn',
        IT_SYSTEMS:                  'cogs',
        OPERATIONS_PLANNING:         'dolly',
        FIELD_RESOURCE_PLANNING:     'users',
    },
    BUDGET:             {
        REPORTING:               'chart bar',
        ENTITY_CATEGORICAL:      'cubes',
        ENTITY_HIRING:           'users',
        ENTITY:                  'dollar sign',
        FEE_COSTS:               'dollar sign',
        OPERATIONAL_COSTS:       'building',
        SCHEDULED_COSTS:         'building',
        ONGOING_COSTS:           'refresh',
        HIRING_COSTS:            'user',
        RECURRENCE_COSTS:        'redo',
        CUSTOM_DATA_CATEGORICAL: 'cube',
        CUSTOM_DATA_HIRING:      'user',
        DATE_RANGE:              'calendar alternate outline',
    },
    META:               {
        TAG:   'tag',
        LINKS: 'linkify',
    },
    RESOURCING:         {
        HIRES: {
            ENTITY: 'user circle'
        }
    }
}

export const ENTITY_COLORIZATION: IEntityColorDefintion = {
    ACTIVITIES: {
        TIMING:      {
            EARLY:  SemanticUIColor.GREEN,
            NORMAL: SemanticUIColor.GREY,
            LATE:   SemanticUIColor.RED,
        },
        CRITICALITY: {
            CRITICAL: SemanticUIColor.RED,
            PRIORITY: SemanticUIColor.VIOLET,
            MODERATE: SemanticUIColor.BLACK,
            MINOR:    SemanticUIColor.GREY,
        },
        RISKS:       {
            LATE_COMPLETION: SemanticUIColor.RED,
            AT_RISK:         SemanticUIColor.ORANGE,
            NONE:            SemanticUIColor.GREY,
        },
    },
    CATEGORIES: {
        GENERIC:                     CorvalUIColor.LIGHTBRINE,
        COMPANY_STRATEGY_PLANNING:   SemanticUIColor.BLUE,
        ASSET_STRATEGY_PLANNING:     SemanticUIColor.BLUE,
        MEDICAL_SCIENTIFIC_AFFAIRS:  SemanticUIColor.TEAL,
        VALUE_MARKET_ACCESS:         SemanticUIColor.TEAL,
        MARKET_DEVELOPMENT_PLANNING: SemanticUIColor.TEAL,
        IT_SYSTEMS:                  SemanticUIColor.PURPLE,
        OPERATIONS_PLANNING:         SemanticUIColor.PURPLE,
        FIELD_RESOURCE_PLANNING:     SemanticUIColor.PURPLE,
    },
    MILESTONES: {
        SYSTEM:                                  SemanticUIColor.RED,
        CUSTOM:                                  CorvalUIColor.LIGHTORANGE,
        PROJECT_START:                           SemanticUIColor.VIOLET,
        INVESTIGATIONALNEWDRUGAPPLICATIONFILING: CorvalUIColor.DARKPINK,
        P2TRIALSTART:                            CorvalUIColor.LIGHTTEAL,
        P2TRIALDATA:                             CorvalUIColor.DARKTEAL,
        P3TRIALSTART:                            CorvalUIColor.LIGHTOLIVE,
        P3TRIALDATA:                             SemanticUIColor.OLIVE,
        NDASUBMISSION:                           CorvalUIColor.LIGHTPURPLE,
        LAUNCHDATE:                              CorvalUIColor.DARKYELLOW,
        NDAAPPROVAL:                             SemanticUIColor.RED
    }
}

export enum INTAKE_QUESTION_CONTEXTS {
    CORE     = 'CORE',
    ADDITIVE = 'ADDITIVE',
    PROJECT  = 'PROJECT',
}

export const INTAKE_QUESTION_CONTEXT_INFO = {
    CORE:     {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.CORE.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.CORE.DESCRIPTION',
        ICON:        'list alternate',
    },
    ADDITIVE: {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.ADDITIVE.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.ADDITIVE.DESCRIPTION',
        ICON:        'tasks',
    },
    PROJECT:  {
        LABEL:       'INTAKE_QUESTION_CONTEXTS.PROJECT.LABEL',
        DESCRIPTION: 'INTAKE_QUESTION_CONTEXTS.PROJECT.DESCRIPTION',
        ICON:        'folder outline',
    },
};

export const OBJECTIVE_FILTERS = {
    CONDITION_TYPES: {
        ALL:         'ALL',
        GENERALIZED: 'GENERALIZED',
        CONDITIONAL: 'CONDITIONAL',
    },
};

export enum SYSTEM_ROLES {
    CORVALADMIN         = 'CORVALADMIN',
    ACCOUNTSADMIN       = 'ACCOUNTSADMIN',
    DECISIONENGINEADMIN = 'DECISIONENGINEADMIN',
    MEMBER              = 'MEMBER'
}

export const SYSTEM_ROLE_INFO = {
    [ SYSTEM_ROLES.CORVALADMIN ]:         {
        LABEL: 'SYSTEM_ROLES.CORVALADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.CORVALADMIN,
    },
    [ SYSTEM_ROLES.ACCOUNTSADMIN ]:       {
        LABEL: 'SYSTEM_ROLES.ACCOUNTSADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.ACCOUNTSADMIN,
    },
    [ SYSTEM_ROLES.DECISIONENGINEADMIN ]: {
        LABEL: 'SYSTEM_ROLES.DECISIONENGINEADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.DECISIONENGINEADMIN,
    },
    [ SYSTEM_ROLES.MEMBER ]:              {
        LABEL: 'SYSTEM_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.SYSTEM.MEMBER,
    },
};

export enum ORGANIZATIONAL_ROLES {
    ADMIN  = 'ADMIN',
    MEMBER = 'MEMBER',
}

export const ORGANIZATIONAL_ROLE_INFO = {
    [ ORGANIZATIONAL_ROLES.ADMIN ]:  {
        LABEL: 'ORGANIZATIONAL_ROLES.ADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.ORGANIZATIONAL.ADMIN,
    },
    [ ORGANIZATIONAL_ROLES.MEMBER ]: {
        LABEL: 'ORGANIZATIONAL_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.ORGANIZATIONAL.MEMBER,
    },
};

export enum PROJECT_ROLES {
    ADMIN  = 'ADMIN',
    MEMBER = 'MEMBER',
    VIEWER = 'VIEWER',
}

export const PROJECT_ROLE_INFO = {
    [ PROJECT_ROLES.ADMIN ]:  {
        LABEL: 'PROJECT_ROLES.ADMIN.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.ADMIN,
    },
    [ PROJECT_ROLES.MEMBER ]: {
        LABEL: 'PROJECT_ROLES.MEMBER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.MEMBER,
    },
    [ PROJECT_ROLES.VIEWER ]: {
        LABEL: 'PROJECT_ROLES.VIEWER.LABEL',
        ICON:  ENTITY_ICONS.USER_ROLES.PROJECT.VIEWER,
    },
};

export enum SUBSCRIPTION_TYPES {
    FREEUNLIMITED = 'FREEUNLIMITED',
}

export const SUBSCRIPTION_TYPE_INFO = {
    [ SUBSCRIPTION_TYPES.FREEUNLIMITED ]: {
        LABEL: 'Free Unlimited',
        ICON:  ENTITY_ICONS.PROJECTS.SUBSCRIPTION_TYPES.FREEUNLIMITED,
    },
};

/* These are functions of a project, and must match the project model */
export type ProjectDetailField =
    'name'
    | 'assetName'
    | 'assetIndication'
    | 'customStartDateUtc';

export type ProjectVersionDetailField =
    'id'
    | 'name'
    | 'description'
    | 'isDefaultVersion'
    | 'isActiveVersion'
    | 'isImmutableBase'
    | 'createdUtc'
    | 'createdById'
    | 'updatedUtc'
    | 'updatedById';

export type ProjectCustomStartDateField = 'customStartDateUtc';
export type ProjectCustomMilestonesField = 'customTimingMilestones';

export enum ProjectMilestoneTypes {
    PROJECT_MILESTONE,
    PROJECT_START_DATE,
    CUSTOM_USER_MILESTONE,
    CURRENT_DATE,
}

export type ProjectMilestoneField =
    'investigationalNewDrugApplicationFilingUtc'
    | 'phase2TrialStartUtc'
    | 'phase2TrialDataUtc'
    | 'phase3TrialStartUtc'
    | 'phase3TrialDataUtc'
    | 'ndaSubmissionUtc'
    | 'launchDateUtc'
    | 'ndaApprovalUtc';

export type ProjectMilestoneType =
    'INVESTIGATIONALNEWDRUGAPPLICATIONFILING'
    | 'P2TRIALSTART'
    | 'P2TRIALDATA'
    | 'P3TRIALSTART'
    | 'P3TRIALDATA'
    | 'NDASUBMISSION'
    | 'LAUNCHDATE'
    | 'NDAAPPROVAL';

export type ProjectModelFields = ProjectDetailField | ProjectMilestoneField;

export const projectTimelineFields: ProjectMilestoneField[] = [
    'investigationalNewDrugApplicationFilingUtc',
    'phase2TrialStartUtc',
    'phase2TrialDataUtc',
    'phase3TrialStartUtc',
    'phase3TrialDataUtc',
    'ndaSubmissionUtc',
    'launchDateUtc',
    'ndaApprovalUtc'
];

export const projectDescFields: ProjectDetailField[] = [
    'assetName',
    'assetIndication',
];

export const projectVersionDetailFields: ProjectVersionDetailField[] = [
    'id',
    'name',
    'description',
    'isDefaultVersion',
    'isActiveVersion',
    'isImmutableBase',
    'createdUtc',
    'createdById',
    'updatedUtc',
    'updatedById',
];

export const projectDetailFields: ProjectDetailField[] = [
    'name',
];

export enum PROJECT_DESC_FIELDS {
    NAME             = 'NAME',
    ASSET_NAME       = 'ASSET_NAME',
    ASSET_INDICATION = 'ASSET_INDICATION',
}

type ProjectDetailInfoItem = {
    LABEL: string,
    DESCRIPTION: string,
    PROJECT_FIELD: ProjectDetailField,
}

export const PROJECT_DESCRIPTION_INFO: Record<any, ProjectDetailInfoItem> = {

    NAME:              {
        LABEL:         'PROJECT_DETAILS.NAME.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.NAME.DESCRIPTION',
        PROJECT_FIELD: 'name',
    },
    ASSET_NAME:        {
        LABEL:         'PROJECT_DETAILS.ASSET_NAME.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.ASSET_NAME.DESCRIPTION',
        PROJECT_FIELD: 'assetName',
    },
    ASSET_INDICATION:  {
        LABEL:         'PROJECT_DETAILS.ASSET_INDICATION.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.ASSET_INDICATION.DESCRIPTION',
        PROJECT_FIELD: 'assetIndication',
    },
    CUSTOM_START_DATE: {
        LABEL:         'PROJECT_DETAILS.CUSTOM_START_DATE.LABEL',
        DESCRIPTION:   'PROJECT_DETAILS.CUSTOM_START_DATE.DESCRIPTION',
        PROJECT_FIELD: 'customStartDateUtc',
    },
};

/* These are functions of a project, and must match the project model */
export const PROJECT_MILESTONES = {
    INVESTIGATIONALNEWDRUGAPPLICATIONFILING: 'INVESTIGATIONALNEWDRUGAPPLICATIONFILING',
    P2TRIALSTART:                            'P2TRIALSTART',
    P2TRIALDATA:                             'P2TRIALDATA',
    P3TRIALSTART:                            'P3TRIALSTART',
    P3TRIALDATA:                             'P3TRIALDATA',
    NDASUBMISSION:                           'NDASUBMISSION',
    LAUNCHDATE:                              'LAUNCHDATE',
    NDAAPPROVAL:                             'NDAAPPROVAL',
};

export type ProjectMilestoneInfoItem = {
    ORDER: number,
    LABEL: string,
    DESCRIPTION: string,
    PROJECT_FIELD: ProjectMilestoneField,
    DEPENDENT_FIELD: ProjectMilestoneField | null,
    COLOR: CorvalColor
}

export const PROJECT_MILESTONE_INFO: Record<keyof typeof PROJECT_MILESTONES, ProjectMilestoneInfoItem> = {

    INVESTIGATIONALNEWDRUGAPPLICATIONFILING: {
        ORDER:           0,
        LABEL:           'PROJECT_MILESTONES.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.INVESTIGATIONALNEWDRUGAPPLICATIONFILING.DESCRIPTION',
        PROJECT_FIELD:   'investigationalNewDrugApplicationFilingUtc',
        DEPENDENT_FIELD: null,
        COLOR:           ENTITY_COLORIZATION.MILESTONES.INVESTIGATIONALNEWDRUGAPPLICATIONFILING,
    },
    P2TRIALSTART:                            {
        ORDER:           1,
        LABEL:           'PROJECT_MILESTONES.P2TRIALSTART.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.P2TRIALSTART.DESCRIPTION',
        PROJECT_FIELD:   'phase2TrialStartUtc',
        DEPENDENT_FIELD: 'investigationalNewDrugApplicationFilingUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.P2TRIALSTART,
    },
    P2TRIALDATA:                             {
        ORDER:           2,
        LABEL:           'PROJECT_MILESTONES.P2TRIALDATA.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.P2TRIALDATA.DESCRIPTION',
        PROJECT_FIELD:   'phase2TrialDataUtc',
        DEPENDENT_FIELD: 'phase2TrialStartUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.P2TRIALDATA,
    },
    P3TRIALSTART:                            {
        ORDER:           3,
        LABEL:           'PROJECT_MILESTONES.P3TRIALSTART.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.P3TRIALSTART.DESCRIPTION',
        PROJECT_FIELD:   'phase3TrialStartUtc',
        DEPENDENT_FIELD: 'investigationalNewDrugApplicationFilingUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.P3TRIALSTART,
    },
    P3TRIALDATA:                             {
        ORDER:           4,
        LABEL:           'PROJECT_MILESTONES.P3TRIALDATA.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.P3TRIALDATA.DESCRIPTION',
        PROJECT_FIELD:   'phase3TrialDataUtc',
        DEPENDENT_FIELD: 'phase3TrialStartUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.P3TRIALDATA,
    },
    NDASUBMISSION:                           {
        ORDER:           5,
        LABEL:           'PROJECT_MILESTONES.NDASUBMISSION.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.NDASUBMISSION.DESCRIPTION',
        PROJECT_FIELD:   'ndaSubmissionUtc',
        DEPENDENT_FIELD: 'phase3TrialDataUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.NDASUBMISSION,
    },
    LAUNCHDATE:                              {
        ORDER:           6,
        LABEL:           'PROJECT_MILESTONES.LAUNCHDATE.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.LAUNCHDATE.DESCRIPTION',
        PROJECT_FIELD:   'launchDateUtc',
        DEPENDENT_FIELD: 'ndaSubmissionUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.LAUNCHDATE,
    },
    NDAAPPROVAL:                             {
        ORDER:           7,
        LABEL:           'PROJECT_MILESTONES.NDAAPPROVAL.LABEL',
        DESCRIPTION:     'PROJECT_MILESTONES.NDAAPPROVAL.DESCRIPTION',
        PROJECT_FIELD:   'ndaApprovalUtc',
        DEPENDENT_FIELD: 'ndaSubmissionUtc',
        COLOR:           ENTITY_COLORIZATION.MILESTONES.NDAAPPROVAL,

    },
};

export type EnumDescriptorType = {
    VALUE: string | number,
    LABEL: string,
    DESCRIPTION: string,
    COLOR: SemanticUIColor | CorvalUIColor,
    ICON?: SemanticICONS,
}

//@ts-ignore
export type EnumDescriptorTypeSet<D> = Record<D, EnumDescriptorType>;

export type ActivityCriticalityField = 'CRITICAL' | 'PRIORITY' | 'MODERATE' | 'MINOR';

export type ActivityCriticalityType = ACTIVITY_CRITICALITY | CorvalCriticality

/* Budget impact levels */
export type ActivityCriticalityTypeSet = EnumDescriptorTypeSet<ActivityCriticalityField>

/* These are the currently assigned values of an activity in the DEM, with descriptions */
export enum ACTIVITY_CRITICALITY {
    CRITICAL = 'CRITICAL',
    PRIORITY = 'PRIORITY',
    MODERATE = 'MODERATE',
    MINOR    = 'MINOR',
}

export const ACTIVITY_CRITICALITY_INFO: ActivityCriticalityTypeSet = {
    CRITICAL: {
        VALUE:       'CRITICAL',
        LABEL:       'ACTIVITY_CRITICALITY.CRITICAL.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.CRITICAL.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.CRITICAL,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.CRITICAL,
    },
    PRIORITY: {
        VALUE:       'PRIORITY',
        LABEL:       'ACTIVITY_CRITICALITY.PRIORITY.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.PRIORITY.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.PRIORITY,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.PRIORITY,
    },
    MODERATE: {
        VALUE:       'MODERATE',
        LABEL:       'ACTIVITY_CRITICALITY.MODERATE.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.MODERATE.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.MODERATE,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.MODERATE,
    },
    MINOR:    {
        VALUE:       'MINOR',
        LABEL:       'ACTIVITY_CRITICALITY.MINOR.LABEL',
        DESCRIPTION: 'ACTIVITY_CRITICALITY.MINOR.DESCRIPTION',
        COLOR:       ENTITY_COLORIZATION.ACTIVITIES.CRITICALITY.MINOR,
        ICON:        ENTITY_ICONS.ACTIVITIES.CRITICALITY.MINOR,
    },
}

export type ActivityStatusField = 'NOTSTARTED' | 'INCOMPLETE' | 'COMPLETE' | 'EXCLUDED'
export type ActivityStatusType = ACTIVITY_STATUS | CorvalCompletionState;
export type ActivityStatusTypeSet = EnumDescriptorTypeSet<ActivityStatusField>

export enum ACTIVITY_STATUS {
    NOTSTARTED = CorvalCompletionState[ 'Notstarted' ],
    INCOMPLETE = CorvalCompletionState[ 'Incomplete' ],
    COMPLETE   = CorvalCompletionState[ 'Complete' ],
    EXCLUDED   = CorvalCompletionState[ 'Excluded' ],
}

export const ACTIVITY_STATUS_INFO: ActivityStatusTypeSet = {
    NOTSTARTED: {
        VALUE:       'NOTSTARTED',
        LABEL:       'ACTIVITY_STATUSES.NOTSTARTED.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.NOTSTARTED.DESCRIPTION',
        COLOR:       SemanticUIColor.PURPLE,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.NOTSTARTED,
    },
    INCOMPLETE: {
        VALUE:       'INCOMPLETE',
        LABEL:       'ACTIVITY_STATUSES.INCOMPLETE.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.INCOMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.INCOMPLETE,
    },
    COMPLETE:   {
        VALUE:       'COMPLETE',
        LABEL:       'ACTIVITY_STATUSES.COMPLETE.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.COMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.GREEN,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.COMPLETE,
    },
    EXCLUDED:   {
        VALUE:       'EXCLUDED',
        LABEL:       'ACTIVITY_STATUSES.EXCLUDED.LABEL',
        DESCRIPTION: 'ACTIVITY_STATUSES.EXCLUDED.DESCRIPTION',
        COLOR:       SemanticUIColor.GREY,
        ICON:        ENTITY_ICONS.ACTIVITIES.STATUSES.EXCLUDED,
    },
}

export enum OBJECTIVE_STATUS {
    NOT_STARTED      = 'NOT_STARTED',
    IN_PROGRESS_LOW  = 'IN_PROGRESS_LOW',
    IN_PROGRESS_MED  = 'IN_PROGRESS_MED',
    IN_PROGRESS_HIGH = 'IN_PROGRESS_HIGH',
    COMPLETE         = 'COMPLETE'
}

export type ObjectiveStatusField = 'NOT_STARTED' | 'IN_PROGRESS_LOW' | 'IN_PROGRESS_MED' | 'IN_PROGRESS_HIGH' | 'COMPLETE'
export type ObjectiveStatusType = OBJECTIVE_STATUS;
export type ObjectiveStatusTypeSet = EnumDescriptorTypeSet<ObjectiveStatusField>
export const OBJECTIVE_STATUS_INFO: ObjectiveStatusTypeSet = {
    NOT_STARTED:      {
        VALUE:       'NOT_STARTED',
        LABEL:       'OBJECTIVE_STATUSES.NOT_STARTED.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.NOT_STARTED.DESCRIPTION',
        COLOR:       SemanticUIColor.GREY,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.NOT_STARTED,
    },
    IN_PROGRESS_LOW:  {
        VALUE:       'IN_PROGRESS_LOW',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_LOW.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_LOW.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_LOW,
    },
    IN_PROGRESS_MED:  {
        VALUE:       'IN_PROGRESS_MED',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_MED.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_MED.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_MED,
    },
    IN_PROGRESS_HIGH: {
        VALUE:       'IN_PROGRESS_HIGH',
        LABEL:       'OBJECTIVE_STATUSES.IN_PROGRESS_HIGH.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.IN_PROGRESS_HIGH.DESCRIPTION',
        COLOR:       SemanticUIColor.TEAL,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.IN_PROGRESS_HIGH,
    },
    COMPLETE:         {
        VALUE:       'COMPLETE',
        LABEL:       'OBJECTIVE_STATUSES.COMPLETE.LABEL',
        DESCRIPTION: 'OBJECTIVE_STATUSES.COMPLETE.DESCRIPTION',
        COLOR:       SemanticUIColor.GREEN,
        ICON:        ENTITY_ICONS.SUBOBJECTIVES.STATUSES.COMPLETE,
    },
}

export type CategoryInfoItem = {
    LABEL: string,
    DESCRIPTION: string,
    ICON: SemanticICONS,
    COLOR: CorvalColor,
}

export type CategoryFieldType = 'COMPANY_STRATEGY_PLANNING' | 'ASSET_STRATEGY_PLANNING' | 'MEDICAL_SCIENTIFIC_AFFAIRS' | 'VALUE_MARKET_ACCESS' | 'MARKET_DEVELOPMENT_PLANNING' | 'IT_SYSTEMS' | 'OPERATIONS_PLANNING' | 'FIELD_RESOURCE_PLANNING'
export const CATEGORY_INFO: Record<CategoryFieldType, CategoryInfoItem> = {
    COMPANY_STRATEGY_PLANNING:
        {
            LABEL:       'Company Strategy & Planning',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.COMPANY_STRATEGY_PLANNING,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.COMPANY_STRATEGY_PLANNING,
        },
    ASSET_STRATEGY_PLANNING:
        {
            LABEL:       'Asset Strategy & Planning',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.ASSET_STRATEGY_PLANNING,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.ASSET_STRATEGY_PLANNING,
        },
    MEDICAL_SCIENTIFIC_AFFAIRS:
        {
            LABEL:       'Medical & Scientific Affairs Development',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.MEDICAL_SCIENTIFIC_AFFAIRS,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.MEDICAL_SCIENTIFIC_AFFAIRS,
        },
    VALUE_MARKET_ACCESS:
        {
            LABEL:       'Value & Market Access Development',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.VALUE_MARKET_ACCESS,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.VALUE_MARKET_ACCESS,
        },
    MARKET_DEVELOPMENT_PLANNING:
        {
            LABEL:       'Market Development & Planning',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.MARKET_DEVELOPMENT_PLANNING,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.MARKET_DEVELOPMENT_PLANNING,
        },
    IT_SYSTEMS:
        {
            LABEL:       'IT/Commercialization Systems & Analytic Development',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.IT_SYSTEMS,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.IT_SYSTEMS,
        },
    OPERATIONS_PLANNING:
        {
            LABEL:       'Operations Planning',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.OPERATIONS_PLANNING,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.OPERATIONS_PLANNING,
        },
    FIELD_RESOURCE_PLANNING:
        {
            LABEL:       'Field Resource Planning',
            DESCRIPTION: '',
            ICON:        ENTITY_ICONS.CATEGORIES.FIELD_RESOURCE_PLANNING,
            COLOR:       ENTITY_COLORIZATION.CATEGORIES.FIELD_RESOURCE_PLANNING,
        },
}

export enum SYSTEM_TEMPLATE_IDS {
    EMPTY_PROJECT   = "00000000-0000-0000-0000-000000000000",
    FULL_PROJECT_3Y = "00000000-0000-0000-0000-000000000003",
    FULL_PROJECT_5Y = "00000000-0000-0000-0000-000000000005",
}

export const SYSTEM_STRING_SIMILARITY_DEFAULT_THRESHOLD = 0.83;
